import { render } from "./video.vue?vue&type=template&id=42a367be&scoped=true"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"

import "./video.vue?vue&type=style&index=0&id=42a367be&scoped=true&lang=css"
import "./video.vue?vue&type=style&index=1&id=42a367be&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42a367be"]])

export default __exports__